import OpenPdf from "../components/OpenPdf";

const Links = () => {
    return (
        <div className="m-3">
            <h1>Unterlagen</h1>
            <div className="m-5">
                <h4>Durchführungsbestimmungen</h4>
                <OpenPdf name="Durchführungsbestimmungen"filePath="documents/FWC23_Durchführungsbestimmungen.pdf" />
            </div>
            <div className="m-5">
            <h4 className="mt-5">Gruppeneinteilung</h4>
            <OpenPdf name="Gruppeneinteilung"filePath="documents/FWC23_Gruppeneinteilung_Stand090323.pdf" />
            </div>
            <div className="m-5">
            <h4 className="mt-5">Spielbericht</h4>
            <OpenPdf name="Spielbericht"filePath="documents/FWC23_Spielbericht_neu.pdf" />
            </div>
            <div className="m-5">
            <h4 className="mt-5">Spielerliste</h4>
            <OpenPdf name="Spielerliste"filePath="documents/FWC23_Spielerliste.pdf" />
            </div>
        </div>
    )
}

export default Links;